/**
 * Instance id the media API resolves to a project's default publication
 * instance. The experience routes make `:instanceId` optional and fall back to
 * it, and it is where a URL carrying an instance the project doesn't have gets
 * redirected.
 */
export const DEFAULT_INSTANCE_ID = "default";
